<template>
  <div>
    <van-row class="top">
      <p><img class="top-img" src="@/assets/images/sfrz.png" /></p>
      <p class="top-text">请输入详细信息完成身份认证</p>
    </van-row>
    <van-row>
      <van-cell-group>
        <van-field v-model="info.UserID" label="学号" placeholder="请输入学号" />
        <van-field v-model="info.IDCrad" label="身份证号" placeholder="请输入身份证号" />
        <van-field v-model="info.Phone" label="手机号" placeholder="请输入手机号" />
      </van-cell-group>
      <div class="btn-box">
        <van-button class="btn" @click="Bind" type="info">提交绑定</van-button>
      </div>
    </van-row>
    <van-row>
      <p class="bottom-text">使用学号及身份证号验证身份，绑定手机号进行使用</p>
    </van-row>
  </div>
</template>
<script>
  import Vue from 'vue'
  import Vant from 'vant';
  import 'vant/lib/index.css';
  Vue.use(Vant)
  export default {
    name: "Bind",
    title: "身份认证",
    data () {
      return {
        info: { Phone: "", UserID: "", IDCrad: "" }
      }
    },
    methods: {
      GetMyInfo () {
        this.Ajax.Get("api/User/GetMyInfo").then(res => {
          this.user = res.data;
          this.isBind = true;
        })
      },
      Bind () {
        this.$tool.Phone.load.show("提交中...");
        this.Ajax.Post("api/Bind/BindStudent/" + this.info.UserID + "/" + this.info.IDCrad + "/" + this.info.Phone + "").then(res => {
          this.$tool.Phone.load.hide();
          this.$tool.Phone.alert("绑定成功，请下载企业微信使用！").then(() => {
            window.location = "https://work.weixin.qq.com";
          })
        })
      }
    },
    mounted () {
      this.$wxtool.GetUserId().then((code) => {
        if (code) {
          this.Ajax.Get("/api/Login/GetTokenByCode/" + this.$config.LoginAppId + "/" + code).then(res => {
            this.$router.push({ name: "UserInfo" });
          });
        }
      })
    },
  }
</script>
<style scoped>
  .top {
    padding: 20px 0;
    text-align: center;
  }
  .top-img {
    width: 40%;
  }
  .top-text {
    padding: 15px 0;
    color: #5ba2d5;
  }
  .btn-box {
    padding: 20px 10px;
  }
  .btn {
    width: 100%;
  }
  .bottom-text {
    text-align: center;
    color: #868686;
    font-size: 14px;
  }
  .tel {
    line-height: 28px;
  }
  .tel a {
    color: #5ba2d5;
  }
</style>